/**
 * "Back to top" links on the about-value / about-equity sections point to
 * #MainContent (see sections/about-value.liquid, sections/about-equity.liquid)
 * so they still work with JS disabled. With JS enabled, intercept the click
 * and smooth-scroll instead, so the URL bar doesn't pick up a #MainContent
 * fragment - matching the behavior of the theme's own back-to-top button
 * (see BackToTop#backToTop in theme.js).
 */
if (!window.__aboutValueBackToTopBound) {
  window.__aboutValueBackToTopBound = true;
  document.addEventListener("click", (event) => {
    const link = event.target.closest(".about-value__back");
    if (!link) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}
